import { render, staticRenderFns } from "./ChargesProductForm.vue?vue&type=template&id=541cecfc&scoped=true&"
import script from "./ChargesProductForm.vue?vue&type=script&lang=js&"
export * from "./ChargesProductForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "541cecfc",
  null
  
)

export default component.exports